import React from 'react'
import classNames from 'classnames'
import { safeHTML } from '../../../../../utils/safeHTML'
import { useTranslation } from '../../../../../translations'
import Toggle from '../../../../baseComponents/gui/toggle/Toggle'
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks'
import { useChallenges } from '../../../../../redux/reducer/content'
import { ACHIEVEMENTS, CHALLENGES } from '../../constants/tabs'
import content from '../../constants/content'
import { useFeatureToggle } from '../../../../../hooks/useFeatureToggle'
import { image } from '../../../../../utils/data/baseUrl'
import { useOpen } from '../../../../../hooks/useOpen'
import Icon from '../../../../baseComponents/gui/icon/Icon'
import { gtmFunctions } from '../../../../../constants/analytics/GTM'

const { toggle } = content

export default function ChallengesHeader() {
  const gameTamagotchiBeauties = useFeatureToggle('gameTamagotchiBeauties')

  const { activeTab } = useChallenges()

  const callbacks = useApplicationCallbacks()
  const { t } = useTranslation()

  const filteredToggle = toggle.filter(
    ({ id }) =>
      ({
        [CHALLENGES]: true,
        [ACHIEVEMENTS]: true,
      }[id]),
  )

  const challengeState = {
    [CHALLENGES]: () => {
      setChallengesActiveTab(CHALLENGES)
      gtmFunctions.GTMChallengesTabs({ tab: CHALLENGES })
    },
    [ACHIEVEMENTS]: () => {
      setChallengesActiveTab(ACHIEVEMENTS)
      gtmFunctions.GTMChallengesTabs({ tab: ACHIEVEMENTS })
    },
  }

  const { setChallengesActiveTab } = callbacks

  const openLink = useOpen()

  const onBannerClick = () => {
    openLink('/loyalty-tasks')
    gtmFunctions.GTMChallengesBanner()
  }

  const bannerCondition = gameTamagotchiBeauties

  return (
    <div className={'challenges__header'}>
      <div className={'challenges__title'}>
        <div className={classNames('challenges__title-item challenges__title-item_active')}>
          {safeHTML(t(filteredToggle.find(({ id }) => id === activeTab).text))}
        </div>
      </div>

      {bannerCondition && (
        <div
          className={'challenges__banner'}
          onClick={onBannerClick}
        >
          <picture>
            <source
              srcSet={image('challenges/banner/mobile.jpg')}
              media='(max-width: 767px)'
            />
            <source
              srcSet={image('challenges/banner/tablet.jpg')}
              media='(min-width: 768px) and (max-width: 1279px)'
            />
            <source
              srcSet={image('challenges/banner/laptop.jpg')}
              media='(min-width: 1280px) and (max-width: 1919px)'
            />
            <source
              srcSet={image('challenges/banner/desktop.jpg')}
              media='(min-width: 1920px)'
            />
            <img
              className='challenges__banner-image'
              src={image('challenges/banner/mobile.jpg')}
              alt='loyalty tasks banner'
            />
          </picture>

          <div className={'challenges__banner-text'}>
            <h3>{safeHTML(t('challenges.tasks.title'))}</h3>
            <span>{safeHTML(t('challenges.tasks.text'))}</span>
          </div>

          <Icon
            className={'challenges__banner-icon'}
            name={'customization/arrow'}
          />
        </div>
      )}

      {filteredToggle?.length > 1 && (
        <div className={classNames('challenges__toggle', { 'challenges__toggle-banner': true })}>
          <Toggle
            list={filteredToggle}
            funcs={challengeState}
            startActive={filteredToggle.findIndex((item) => item.id === activeTab)}
            className={'toggle_challenges'}
          />
        </div>
      )}
    </div>
  )
}
